import { Theme } from "@radix-ui/themes"
import { type ReactNode } from "react"

interface ThemeProviderProps {
  children: ReactNode
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  return (
    <Theme
      accentColor="indigo"
      grayColor="mauve"
      radius="small"
      scaling="95%"
      style={{ "--color-background": "var(--mauve-2)" } as React.CSSProperties}
    >
      {children}
    </Theme>
  )
}
